import { ContainerComponent } from "../ui";
import { AttractionsCarouselComponent } from "./AttractionsCarouselComponent";
import { TrustStatsComponent } from "./TrustStatsComponent";
import { WhyUsComponent } from "./WhyUsComponent";
import { Wrapper } from "./Home.style";

const Home = () => {
  return (
    <ContainerComponent fixed style={{ width: "100%" }}>
      <Wrapper>
        <WhyUsComponent />
        <TrustStatsComponent />
        <AttractionsCarouselComponent />
      </Wrapper>
    </ContainerComponent>
  );
};

export default Home;
